import { render, staticRenderFns } from "./WealthBuilderPlan.vue?vue&type=template&id=5e79ea68&scoped=true"
import script from "./WealthBuilderPlan.vue?vue&type=script&lang=js"
export * from "./WealthBuilderPlan.vue?vue&type=script&lang=js"
import style0 from "./WealthBuilderPlan.vue?vue&type=style&index=0&id=5e79ea68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79ea68",
  null
  
)

export default component.exports